<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <image-swiper :swiperList="swiperList"></image-swiper>
      <news-list :news="news"></news-list>
    </div>
  </div>
</template>

<script>
import ImageSwiper from './components/ImageSwiper.vue'
import NewsList from './components/NewsList.vue'

import newsMixins from '@/mixins/newsMixins.js'

export default {
  name: 'PcHomeNews',
  mixins: [newsMixins],
  components: {
    ImageSwiper,
    NewsList,
  },
}
</script>

<style lang="scss" scoped>
.module {
  height: 1040px;

  &__title {
    background-position: center 0;
  }

  &__content {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    margin-top: 51px;
    padding: 78px 67px 0;
    width: 1334px;
    height: 544px;
    background: url('~@/assets/img/pc/news_bg.png') no-repeat;
  }
}
</style>